module.exports = __webpack_public_path__ + "static/media/projectPic8.be2342c6.png";